import { render, staticRenderFns } from "./SyaratKumpulPopup.vue?vue&type=template&id=15fe6086&scoped=true"
import script from "./SyaratKumpulPopup.vue?vue&type=script&lang=js"
export * from "./SyaratKumpulPopup.vue?vue&type=script&lang=js"
import style0 from "./SyaratKumpulPopup.vue?vue&type=style&index=0&id=15fe6086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe6086",
  null
  
)

export default component.exports